import { AuthenticationService } from '../services/authentication.service';

export function appInitializer(authenticationService: AuthenticationService): any {
  return () => {
    // attempt to refresh token on app start up to auto authenticate
    authenticationService.getCurrentUser();
  };
}
